import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addUserApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addUser = createAsyncThunk('addUser', async (payload) => {
  return await addUserApi(payload);
});

const addUserSlice = createSlice({
  name: 'addUser', // Unique Name
  initialState,
  reducers: {
    addUserReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addUser.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addUser.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addUser.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addUserReset } = addUserSlice.actions;

export default addUserSlice.reducer;
